import React from 'react';
import VersionsIcon from '@material-ui/icons/AllInbox';
import {
  FasFileChartLine, FasChartNetwork, FasFlask, FasFileInvoice,
  FasFileSearch, FasFileInvoiceDollar, FasCopy, FasLightbulbOn, FasTools
} from 'assets/icons';

const OPENIcon = () => (
  <svg id="OPEN-icon" data-name="OPEN" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 374.01 333.32" focusable="false" aria-hidden="true" role="presentation">
    <title>OPEN</title>
    <path fill="CurrentColor" d="M266.88,264.11a1.32,1.32,0,0,1,2,1.69c-26.86,38.9-69.8,64.09-118.18,64.09C69.36,329.89,3.4,258.65,3.4,170.78c0-46.53,18.49-88.39,48-117.48a2.65,2.65,0,0,1,4.05,3.38,164.42,164.42,0,0,0-27.67,92.1c0,86,64,155.77,143,155.77C207.76,304.55,241.49,289.24,266.88,264.11Z" />
    <path fill="CurrentColor" d="M241.84,259.66a1.35,1.35,0,0,1,.93,2.44,115.1,115.1,0,0,1-65.46,20.65c-69.73,0-126.25-63.79-126.25-142.49C51.06,75,89.9,20,142.92,3.14a1.35,1.35,0,0,1,1.26,2.34c-32,26.07-52.52,66.75-52.52,112.46,0,78.69,60.92,142.48,136.06,142.48A131.74,131.74,0,0,0,241.84,259.66Z" />
    <path fill="CurrentColor" d="M331,196.84c0,68-42.79,125-100.1,139.45a1.5,1.5,0,0,1-1.27-2.65c33.59-25.37,55.6-67.72,55.6-115.69,0-77.62-57.64-140.54-128.73-140.54a118.3,118.3,0,0,0-23.32,2.3A1.5,1.5,0,0,1,132,77a119.07,119.07,0,0,1,70.27-23.19C273.4,53.83,331,117.86,331,196.84Z" />
    <path fill="CurrentColor" d="M377.4,168.88c0,57.77-25.79,108.64-64.91,138.33a2,2,0,0,1-2.67-2.82c24.61-29.1,39.82-69.19,39.82-113.45,0-88.88-61.33-160.93-137-160.93-36.81,0-70.23,17.05-94.84,44.81a2,2,0,0,1-3.14-2.33C141,30.43,184,3,232.56,3,312.56,3,377.4,77.28,377.4,168.88Z" />
  </svg>
);

const IntergrationsIcon = () => (
  <svg id="Integrations-icon" data-name="Integrations" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" focusable="false" aria-hidden="true" role="presentation">
    <title>Integrations</title>
    <path
      fill="CurrentColor"
      d="M493,329.8c-11.1,35.7-30,67.9-54.7,94.6c-3.8,4.2-9.9,5.1-14.8,2.3l-42.6-24.6c-18,15.3-38.6,27.2-60.8,35.1v49.2
      c0,5.6-3.9,10.5-9.4,11.7c-34.9,7.8-72.5,8.2-109.2,0c-5.5-1.2-9.4-6.1-9.4-11.7v-49.2c-22.3-7.8-42.9-19.7-60.8-35.1l-42.6,24.6
      c-4.8,2.8-11,1.8-14.8-2.3c-24.7-26.8-43.6-59-54.7-94.6c-1.6-5.4,0.6-11.2,5.5-14l35.5-20.5c6.3,17.2,22.8,28.9,41.2,28.9
      c4,0,8.1-0.6,12-1.7l59.3-16.6c17.2,28,48,46.6,83.3,46.6c53.9,0,97.6-43.7,97.6-97.7c0-49.9-37.4-91.1-85.7-96.9l-20.6-73.6
      c-5.3-18.9-22.7-32.1-42.3-32.1c-4,0-8.1,0.6-12,1.7l-1,0.3V25.8c0-5.6,3.9-10.5,9.4-11.7c34.9-7.8,72.5-8.2,109.2,0
      c5.5,1.2,9.4,6.1,9.4,11.7v49.1c22.3,7.8,42.9,19.7,60.8,35.1l42.6-24.6c4.8-2.8,11-1.8,14.8,2.3c24.7,26.8,43.6,59,54.7,94.6
      c1.6,5.4-0.6,11.2-5.5,14l-42.6,24.6c4.3,23.2,4.3,47,0,70.2l42.6,24.6C492.3,318.5,494.5,324.3,493,329.8z"
    />
    <path
      fill="CurrentColor"
      d="M158.7,109.1l13.6,48.5L48.4,88c-11.6-6.5-26.2-2.4-32.7,9.2L4,118.1c-6.5,11.6-2.4,26.2,9.2,32.7L137,220.4L88.5,234
      c-12.8,3.6-20.2,16.8-16.6,29.6l6.5,23.1c3.6,12.8,16.8,20.2,29.6,16.6L251.6,263c12.8-3.6,20.2-16.8,16.6-29.6L228,89.7
      c-3.6-12.8-16.8-20.2-29.6-16.6l-23.1,6.5C162.5,83.2,155,96.4,158.7,109.1z"
    />
  </svg>
);

export const Protocol = {
  protocoldetail: {
    id: 'protocoldetail',
    title: 'Protocol Details',
    shortname: 'Details',
    icon: FasFileChartLine
  },
  participation: {
    id: 'participation',
    title: 'Participation',
    icon: FasChartNetwork
  },
  versions: {
    id: 'versions',
    title: 'Versions',
    icon: VersionsIcon
  },
  studyagent: {
    id: 'studyagent',
    title: 'Study Agents',
    icon: FasFlask
  },
  psrs: {
    id: 'psrs',
    title: 'Protocol Specific Requirements (PSRs)',
    shortname: 'PSRs',
    icon: FasFileInvoice
  },
  cirb: {
    id: 'cirb',
    title: 'CIRB',
    icon: FasFileSearch
  },
  opensetup: {
    id: 'opensetup',
    title: 'OPEN Setup',
    icon: OPENIcon
  },
  integrations: {
    id: 'integrations',
    title: 'Integrations',
    icon: IntergrationsIcon
  },
  funding: {
    id: 'funding',
    title: 'Funding',
    icon: FasFileInvoiceDollar
  },
  documents: {
    id: 'documents',
    title: 'Documents',
    icon: FasCopy
  },
  insights: {
    id: 'insights',
    title: 'Insights',
    icon: FasLightbulbOn
  },
  /*
    RSSMOD-906: https://jira.westat.com/browse/RSSMOD-906
  */
  admin: {
    id: 'admin',
    title: 'Admin',
    icon: FasTools
  }
};

export const CohortsData = [{
  cohortName: 'A',
  strata: 'Yes',
  description: 'Depending on length, the user would click on text and see full text',
  status: 'Open',
  reason: null,
  statusDate: 'dd-MMM-yyyy',
  accrualTarget: '#',
  currentAccrual: '#',
  strataList: [{
    cohort: 'A',
    stratum: 'A-1',
    description: 'Depending on length, the user would click on text and see full text',
    status: 'Open',
    reason: null,
    statusDate: 'dd-MMM-yyyy',
    accrualTarget: '#',
    currentAccrual: '#'
  }, {
    cohort: 'A',
    stratum: 'A-2',
    description: 'Depending on length, the user would click on text and see full text',
    status: 'Open',
    reason: null,
    statusDate: 'dd-MMM-yyyy',
    accrualTarget: '#',
    currentAccrual: '#'
  }, {
    cohort: 'A',
    stratum: 'A-3',
    description: 'Depending on length',
    status: 'Closed',
    reason: 'Reason text here',
    statusDate: 'dd-MMM-yyyy',
    accrualTarget: '#',
    currentAccrual: '#'
  }]
}, {
  cohortName: 'B',
  strata: 'Yes',
  description: 'Depending on length, the user would click on text and see full text',
  status: 'Open',
  reason: null,
  statusDate: 'dd-MMM-yyyy',
  accrualTarget: '#',
  currentAccrual: '#',
  strataList: [{
    cohort: 'B',
    stratum: 'B-1',
    description: 'Depending on length, the user would click on text and see full text',
    status: 'Open',
    reason: null,
    statusDate: 'dd-MMM-yyyy',
    accrualTarget: '#',
    currentAccrual: '#'
  }, {
    cohort: 'B',
    stratum: 'B-2',
    description: 'Depending on length, the user would click on text and see full text',
    status: 'Open',
    reason: null,
    statusDate: 'dd-MMM-yyyy',
    accrualTarget: '#',
    currentAccrual: '#'
  }, {
    cohort: 'B',
    stratum: 'B-3',
    description: 'Depending on length',
    status: 'Closed',
    reason: 'Reason text here',
    statusDate: 'dd-MMM-yyyy',
    accrualTarget: '#',
    currentAccrual: '#'
  }]
}, {
  cohortName: 'C',
  strata: 'No',
  description: 'Depending on length',
  status: 'Open',
  reason: null,
  statusDate: 'dd-MMM-yyyy',
  accrualTarget: '#',
  currentAccrual: '#',
  strataList: [{
    cohort: 'C',
    stratum: 'C-1',
    description: 'Depending on length, the user would click on text and see full text',
    status: 'Open',
    reason: null,
    statusDate: 'dd-MMM-yyyy',
    accrualTarget: '#',
    currentAccrual: '#'
  }, {
    cohort: 'C',
    stratum: 'C-2',
    description: 'Depending on length',
    status: 'Open',
    reason: null,
    statusDate: 'dd-MMM-yyyy',
    accrualTarget: '#',
    currentAccrual: '#'
  }, {
    cohort: 'C',
    stratum: 'C-3',
    description: 'Depending on length, the user would click on text and see full text',
    status: 'Closed',
    reason: 'Reason text here',
    statusDate: 'dd-MMM-yyyy',
    accrualTarget: '#',
    currentAccrual: '#'
  }]
}];

export const CohortsArmData = [{
  cohortName: 'A',
  description: 'Depending on length, the user would click on text and see full text',
  status: 'Open',
  reason: null,
  statusDate: 'dd-MMM-yyyy',
  reservedSlot: '#',
  accrualTarget: '#',
  currentAccrual: '#',
  armsList: [{
    cohort: 'A',
    arm: 'A-1',
    description: 'Depending on length, the user would click on text and see full text',
    status: 'Open',
    reason: null,
    statusDate: 'dd-MMM-yyyy',
    accrualTarget: '#',
    currentAccrual: '#'
  }, {
    cohort: 'A',
    arm: 'A-2',
    description: 'Depending on length, the user would click on text and see full text',
    status: 'Open',
    reason: null,
    statusDate: 'dd-MMM-yyyy',
    accrualTarget: '#',
    currentAccrual: '#'
  }, {
    cohort: 'A',
    arm: 'A-3',
    description: 'Depending on length',
    status: 'Closed',
    reason: 'Reason text here',
    statusDate: 'dd-MMM-yyyy',
    accrualTarget: '#',
    currentAccrual: '#'
  }]
}, {
  cohortName: 'B',
  description: 'Depending on length, the user would click on text and see full text',
  status: 'Open',
  reason: null,
  statusDate: 'dd-MMM-yyyy',
  reservedSlot: '#',
  accrualTarget: '#',
  currentAccrual: '#',
  armsList: [{
    cohort: 'B',
    arm: 'B-1',
    description: 'Depending on length, the user would click on text and see full text',
    status: 'Open',
    reason: null,
    statusDate: 'dd-MMM-yyyy',
    accrualTarget: '#',
    currentAccrual: '#'
  }, {
    cohort: 'B',
    arm: 'B-2',
    description: 'Depending on length, the user would click on text and see full text',
    status: 'Open',
    reason: null,
    statusDate: 'dd-MMM-yyyy',
    accrualTarget: '#',
    reservedSlot: '#',
    currentAccrual: '#'
  }, {
    cohort: 'B',
    arm: 'B-3',
    description: 'Depending on length',
    status: 'Closed',
    reason: 'Reason text here',
    statusDate: 'dd-MMM-yyyy',
    accrualTarget: '#',
    reservedSlot: '#',
    currentAccrual: '#'
  }]
}, {
  cohortName: 'C',
  description: 'Depending on length',
  status: 'Open',
  reason: null,
  statusDate: 'dd-MMM-yyyy',
  accrualTarget: '#',
  currentAccrual: '#',
  reservedSlot: '#',
  armsList: [{
    cohort: 'C',
    arm: 'C-1',
    description: 'Depending on length, the user would click on text and see full text',
    status: 'Open',
    reason: null,
    statusDate: 'dd-MMM-yyyy',
    accrualTarget: '#',
    currentAccrual: '#'
  }, {
    cohort: 'C',
    arm: 'C-2',
    description: 'Depending on length',
    status: 'Open',
    reason: null,
    statusDate: 'dd-MMM-yyyy',
    accrualTarget: '#',
    currentAccrual: '#'
  }, {
    cohort: 'C',
    arm: 'C-3',
    description: 'Depending on length, the user would click on text and see full text',
    status: 'Closed',
    reason: 'Reason text here',
    statusDate: 'dd-MMM-yyyy',
    accrualTarget: '#',
    currentAccrual: '#'
  }]
}];